// extracted by mini-css-extract-plugin
export default {"indicator":"styles_indicator__T1U19","spinner":"styles_spinner__j0aCX","rotate":"styles_rotate__cJfAs","error":"styles_error__k0+Ff"};